/**
 * App core
 * ------
 * Shared vendor + app modules loaded by every per-site entry (app.js, rcmc-app.js).
 * Site-specific modules (e.g. the featured-carousel Swiper init) are required from the
 * individual entry files so the two sites can diverge independently.
 */

// Bootstrap requires
require("./vendor/bootstrap-requires.js");

require("axios");

var _ = require("lodash");

import { createApp } from "vue";
import InstantSearch from "vue-instantsearch/vue3/es";
const aa = require("search-insights");

window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

// let SnazzyInfoWindow = require('../vendor/snazzy-info-window.min');

// Search apps: PHP renders a [data-vue-component] placeholder with data-query; no runtime template compiler needed.
const searchEl = document.querySelector("[data-vue-component]");
if (searchEl) {
  const files = require.context("./", true, /\.vue$/i);
  const key = files
    .keys()
    .find((k) => k.split("/").pop().split(".")[0] === searchEl.dataset.vueComponent);
  if (key) {
    const siteSearch = createApp(files(key).default, {
      query_in: searchEl.dataset.query || "",
    });
    siteSearch.use(InstantSearch);
    siteSearch.config.globalProperties.aa = aa;
    siteSearch.config.globalProperties.userIp = window.userIp;
    siteSearch.mount(searchEl);
  }
}

// Sliders
require("./app/sliders/testimonial");
require("./app/sliders/article-list");
require("./app/sliders/gallery");
require("./app/sliders/testimonial-video");

require("./vendor/slick.min");

// ScrollTrigger
// require('./app/scrollTrigger);

// App Requires
// require('./app/config');
require('./app/helpers');
require("./app/site-header.js");
require("./app/location-cards.js");
require("./app/filter-panels.js");
require("./app/gravity-form-overwrite.js");
require("./app/videos.js");
require("./app/grid-info.js");
require("./app/photo-gallery.js");
require("./app/blocks/magazine.js");

require("./app/blocks/services-search.js");
require("./app/blocks/episodes-search.js");
require("./app/blocks/career-search.js");
require("./app/blocks/press-releases.js");
require("./app/blocks/featured-episodes");
require("./app/blocks/podcast-transcript.js");

require("./app/blocks/patient-stories.js");
require("./app/blocks/team-member.js");
require("./app/blocks/doctors-providers.js");
require("./app/blocks/mayo.js");
require("./app/blocks/donation-stats.js");
require("./app/blocks/hero-actions.js");
require("./app/blocks/forms.js");
require("./app/sliders/hero-actions.js");
require("./app/sliders/image-copy.js");

$('#dropdownMenuButton').on('click', function () {
    $('#dropdownMenuButton').toggleClass('active');
    $('#dropdownMenu').slideToggle();
});
